
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6Q7Aj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $dAlan = parcelRequire("dAlan");


var $bWsrO = parcelRequire("bWsrO");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $cBlwX = parcelRequire("cBlwX");

const $92ba67c06540f049$var$mapResponseToLabels = (data)=>{
    if (!data) return undefined;
    const connection = data.confluence_popularLabelsMacro;
    if (connection == null) return undefined;
    const nodes = connection.nodes;
    if (!nodes) return [];
    const labels = [];
    for (const node of nodes){
        if (node == null || node.labelId == null || node.name == null) continue;
        labels.push({
            name: node.name,
            rank: node.rank ?? 0,
            labelId: node.labelId
        });
    }
    return labels;
};
const $92ba67c06540f049$export$ec4acca008211b2a = ({ spaceId: spaceId, first: first, style: style, skip: skip })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const variables = {
        cloudId: cloudId,
        first: first,
        style: (0, $cBlwX.toStyleEnum)(style),
        spaceId: spaceId
    };
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $bWsrO.default), // Preserve GraphQL errors returned with partial data so the renderer's
    // existing error state wins over the empty-state branch.
    {
        variables: variables,
        skip: !!skip,
        errorPolicy: 'all',
        fetchPolicy: 'cache-first',
        __callerPackage__: "popular-labels-macro"
    });
    const isAwaitingInitialResult = !skip && data === undefined && !error;
    return {
        data: $92ba67c06540f049$var$mapResponseToLabels(data),
        loading: loading || isAwaitingInitialResult,
        error: error ?? null
    };
};
const $92ba67c06540f049$export$b74f7c5817731662 = ({ spaceKey: spaceKey, first: first, style: style })=>{
    const { data: spaceData, loading: spaceLoading, error: spaceError } = (0, $jMyy4.useQueryInterop)((0, $dAlan.default), {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "popular-labels-macro"
    });
    const resolvedSpaceId = spaceData?.space?.id ?? null;
    const spaceIsAwaitingInitialResult = spaceData === undefined && !spaceLoading && !spaceError;
    const spaceUnresolved = !spaceIsAwaitingInitialResult && !spaceLoading && !spaceError && !resolvedSpaceId;
    // Skip the labels query whenever we don't have a real spaceId — this
    // covers all three "not ready" cases: still loading, errored, and
    // settled-with-no-match.
    const result = $92ba67c06540f049$export$ec4acca008211b2a({
        spaceId: resolvedSpaceId,
        first: first,
        style: style,
        skip: !resolvedSpaceId
    });
    return {
        // When the space lookup settled with no match, surface an empty list so
        // the renderer falls into its empty-state branch — matching the legacy
        // backend macro's behavior for unresolvable `spaceKey` values.
        data: spaceUnresolved ? [] : result.data,
        loading: spaceLoading || spaceIsAwaitingInitialResult || result.loading,
        error: spaceError ?? result.error
    };
};





const $a5784c0482f9869f$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    noLabelsFound: {
        id: "popular-labels-macro.no-labels-found",
        defaultMessage: "No labels match these criteria."
    },
    error: {
        id: "popular-labels-macro.error",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We're unable to display the popular labels. Refresh to try again"
    }
});


/* ListLayout.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $7vK9E = parcelRequire("7vK9E");


var $dinVW = parcelRequire("dinVW");


var $eATLT = parcelRequire("eATLT");

const $86f068e1e04ceda7$var$styles = {
    list: "_0aNu0LYbGa _0LQT5EPgdg",
    link: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $86f068e1e04ceda7$export$cacbb3924155d68e = ({ labels: labels, spaceKey: spaceKey, linkTarget: linkTarget })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        as: "ul",
        xcss: $86f068e1e04ceda7$var$styles.list,
        testId: "popular-labels-list"
    }, labels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: label.labelId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: (0, $eATLT.buildLabelUrl)(label.name, spaceKey),
            target: linkTarget,
            xcss: $86f068e1e04ceda7$var$styles.link
        }, label.name))));
};


/* HeatmapLayout.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $1l0kj = parcelRequire("1l0kj");




const $f9da32773e023cc8$var$styles = {
    link: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
// Match the legacy `.heatmap ul { line-height: 2em }` rule. Setting this on
// each anchor in `rem` (root-relative) instead of `em` (own-font-relative)
// gives every label a uniform ~32px line-height regardless of its own
// `fontSize`, so wrapped rows stay tight even when individual labels scale
// up to 1.75em — matching the legacy heatmap.
const $f9da32773e023cc8$var$HEATMAP_LINE_HEIGHT = '2rem'; // Legacy macro renders each label at `12 + rank * 2` px (popularlabels.vm).
// Express the same ramp in `em` so the heatmap stays relative to the host
// page's body font-size: assuming a 16px body, rank 1 → 0.875em (= 14px) and
// rank 8 → 1.75em (= 28px), matching the legacy output exactly.
const $f9da32773e023cc8$var$BASE_FONT_EM = 0.75;
const $f9da32773e023cc8$var$RANK_INCREMENT_EM = 2 / 16;
const $f9da32773e023cc8$var$getHeatmapFontSize = (rank)=>{
    return `${$f9da32773e023cc8$var$BASE_FONT_EM + rank * $f9da32773e023cc8$var$RANK_INCREMENT_EM}em`;
};
const $f9da32773e023cc8$export$5ceb96508526d103 = ({ labels: labels, spaceKey: spaceKey, linkTarget: linkTarget })=>{
    return(// Heatmap labels mix several font sizes — align them by text baseline so
    // they flow on the same line like running text (matching the legacy
    // macro), rather than being top-aligned as the Inline primitive defaults
    // to via flexbox.
    //
    // `space` applies to BOTH column and row gaps by default; that adds an
    // extra 8px between wrapped rows on top of each row's line-height,
    // making the layout feel sparse compared to legacy. Pin `rowSpace` to
    // zero so wrapped rows are spaced purely by each label's fixed
    // line-height (set inline via `HeatmapLabel`) — matching legacy's
    // behavior of fixing row height regardless of any single child's
    // font-size.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        rowSpace: "space.0",
        shouldWrap: true,
        alignBlock: "baseline",
        testId: "popular-labels-heatmap"
    }, labels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            key: label.labelId,
            href: (0, $eATLT.buildLabelUrl)(label.name, spaceKey),
            target: linkTarget,
            xcss: $f9da32773e023cc8$var$styles.link,
            // against a single fixed row height (legacy parity: `.heatmap ul {
            // line-height: 2em }` + `<li style="font-size:Npx">`). Typography
            // tokens bundle font-size and line-height together and can't model
            // this 1-to-many shape, so we set both properties inline.
            style: {
                fontSize: $f9da32773e023cc8$var$getHeatmapFontSize(label.rank),
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/enforce-style-prop
                lineHeight: $f9da32773e023cc8$var$HEATMAP_LINE_HEIGHT
            }
        }, label.name))));
};





const $e8ae6164b9a89a6c$var$PopularLabelsView = ({ trackingAttributes: trackingAttributes, trackingContentId: trackingContentId, trackingExtensionKey: trackingExtensionKey, trackingMode: trackingMode, trackingName: trackingName, macroId: macroId, spaceKey: spaceKey, layoutStyle: layoutStyle, labels: labels, loading: loading, error: error, linkTarget: linkTarget })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorMessage = formatMessage((0, $a5784c0482f9869f$export$a7357cdd1f0b0168).error);
    if (loading) return null;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: trackingName,
        contentId: trackingContentId,
        extensionKey: trackingExtensionKey,
        mode: trackingMode,
        attributes: trackingAttributes,
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "popular-labels-error-state"
    }, errorMessage)));
    if (!labels) {
        const labelsError = new Error(formatMessage((0, $a5784c0482f9869f$export$a7357cdd1f0b0168).error));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: trackingName,
            contentId: trackingContentId,
            extensionKey: trackingExtensionKey,
            mode: trackingMode,
            attributes: trackingAttributes,
            error: labelsError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: labelsError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "popular-labels-error-state"
        }, errorMessage)));
    }
    if (labels.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: trackingName,
        contentId: trackingContentId,
        extensionKey: trackingExtensionKey,
        mode: trackingMode,
        attributes: trackingAttributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "popular-labels-empty-state"
    }, formatMessage((0, $a5784c0482f9869f$export$a7357cdd1f0b0168).noLabelsFound)));
    const LayoutComponent = layoutStyle === 'heatmap' ? (0, $f9da32773e023cc8$export$5ceb96508526d103) : (0, $86f068e1e04ceda7$export$cacbb3924155d68e);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: trackingName,
        contentId: trackingContentId,
        extensionKey: trackingExtensionKey,
        mode: trackingMode,
        attributes: trackingAttributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "popular-labels-macro",
        "data-fabric-macro": macroId,
        "data-macro-body": ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LayoutComponent, {
        labels: labels,
        spaceKey: spaceKey,
        linkTarget: linkTarget
    })));
};
const $e8ae6164b9a89a6c$var$GlobalPopularLabelsRenderer = ({ trackingAttributes: trackingAttributes, trackingContentId: trackingContentId, trackingExtensionKey: trackingExtensionKey, trackingMode: trackingMode, trackingName: trackingName, macroId: macroId, first: first, layoutStyle: layoutStyle, linkTarget: linkTarget })=>{
    const { data: labels, loading: loading, error: error } = (0, $92ba67c06540f049$export$ec4acca008211b2a)({
        spaceId: null,
        first: first,
        style: layoutStyle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8ae6164b9a89a6c$var$PopularLabelsView, {
        trackingAttributes: trackingAttributes,
        trackingContentId: trackingContentId,
        trackingExtensionKey: trackingExtensionKey,
        trackingMode: trackingMode,
        trackingName: trackingName,
        macroId: macroId,
        spaceKey: undefined,
        layoutStyle: layoutStyle,
        labels: labels,
        loading: loading,
        error: error,
        linkTarget: linkTarget
    });
};
const $e8ae6164b9a89a6c$var$SpaceScopedPopularLabelsRenderer = ({ trackingAttributes: trackingAttributes, trackingContentId: trackingContentId, trackingExtensionKey: trackingExtensionKey, trackingMode: trackingMode, trackingName: trackingName, macroId: macroId, first: first, layoutStyle: layoutStyle, spaceKey: spaceKey, linkTarget: linkTarget })=>{
    const { data: labels, loading: loading, error: error } = (0, $92ba67c06540f049$export$b74f7c5817731662)({
        spaceKey: spaceKey,
        first: first,
        style: layoutStyle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8ae6164b9a89a6c$var$PopularLabelsView, {
        trackingAttributes: trackingAttributes,
        trackingContentId: trackingContentId,
        trackingExtensionKey: trackingExtensionKey,
        trackingMode: trackingMode,
        trackingName: trackingName,
        macroId: macroId,
        spaceKey: spaceKey,
        layoutStyle: layoutStyle,
        labels: labels,
        loading: loading,
        error: error,
        linkTarget: linkTarget
    });
};
const $e8ae6164b9a89a6c$var$PopularLabelsMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const trackingMode = mode === 'live' ? 'renderer' : mode;
    const trackingAttributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const trackingName = (0, $5kjCz.getExperienceName)(trackingMode, node);
    const count = (0, $cBlwX.parseCount)(macroParams?.count?.value);
    const style = (0, $cBlwX.parseStyle)(macroParams?.style?.value);
    // Resolve the legacy `'currentSpace()'` sentinel to the host page's space
    // key before deciding between the global vs. space-scoped renderer.
    const spaceKey = (0, $cBlwX.resolveSpaceKey)(macroParams?.spaceKey?.value, macroParams?.currentSpaceKey);
    // In view mode (`renderer`) labels behave like normal page links and
    // navigate in place. In authoring surfaces we open them in a new tab so
    // authors don't lose their unsaved draft when inspecting a label.
    const linkTarget = macroDefaultProps?.mode === 'editor' || macroDefaultProps?.mode === 'live' ? '_blank' : undefined;
    const macroId = typeof macroDefaultProps?.attributes?.macroId === 'string' ? macroDefaultProps.attributes.macroId : undefined;
    if (spaceKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8ae6164b9a89a6c$var$SpaceScopedPopularLabelsRenderer, {
        trackingAttributes: trackingAttributes,
        trackingContentId: contentId,
        trackingExtensionKey: extensionKey,
        trackingMode: trackingMode,
        trackingName: trackingName,
        macroId: macroId,
        first: count,
        layoutStyle: style,
        spaceKey: spaceKey,
        linkTarget: linkTarget
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8ae6164b9a89a6c$var$GlobalPopularLabelsRenderer, {
        trackingAttributes: trackingAttributes,
        trackingContentId: contentId,
        trackingExtensionKey: extensionKey,
        trackingMode: trackingMode,
        trackingName: trackingName,
        macroId: macroId,
        first: count,
        layoutStyle: style,
        linkTarget: linkTarget
    });
};
const $e8ae6164b9a89a6c$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a5784c0482f9869f$export$a7357cdd1f0b0168).error);
const $e8ae6164b9a89a6c$export$f021861a5135caf4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $e8ae6164b9a89a6c$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8ae6164b9a89a6c$var$PopularLabelsMacroRendererComponent, props));
};
module.exports["PopularLabelsMacroRenderer"] = $e8ae6164b9a89a6c$export$f021861a5135caf4;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("eATLT", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");


var $1NBp8 = parcelRequire("1NBp8");

const $dc31057420aa5644$export$6aee0ce422e62102 = (labelName, spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.LABELLED_CONTENT).toUrl({
        spaceKey: spaceKey,
        labelName: encodeURIComponent(labelName)
    });
    return `${0, $jlIaF.CONTEXT_PATH}/label/${encodeURIComponent(labelName)}`;
};
module.exports["buildLabelUrl"] = $dc31057420aa5644$export$6aee0ce422e62102;

});


//# sourceMappingURL=PopularLabelsMacroRenderer.afa3ac0d.js.map
